import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
export default React.memo(function Checkbox({ label = '', labelPosition = 'right', checked = false, partialChecked = false, onChange, onPartialChange, style, color = 'var(--accent-blue)', name, className, }) {
    const onClick = () => {
        if (partialChecked) {
            onChange === null || onChange === void 0 ? void 0 : onChange(false);
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
        }
    };
    return (_jsxs(Container, { labelPosition: labelPosition, style: style, color: color, checked: checked, onClick: onClick, className: `${className} ui-checkbox`, name: name, children: [label && labelPosition === 'left' && _jsx("label", { children: label }), _jsxs("div", { className: 'box', children: [checked && !partialChecked && _jsx("span", { children: "\u2713" }), partialChecked && !checked && _jsx("span", { children: "\u2013" })] }), label && labelPosition === 'right' && _jsx("label", { children: label })] }));
});
const Container = styled.div `
    cursor: pointer;
    display: flex;
    align-items: center;
    color: var(--text-primary);
    font-weight: bold;

    & > label {
        margin-left: 0.625em !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        font-size: 0.875rem;
        font-weight: 500;
        user-select: none;
        cursor: pointer;

        ${p => p.labelPosition === 'left' && css `
          margin-left: 0;
          margin-right: 0.625em;
        `}
    }

    & .box {
        display: flex;
        width: 1.125rem;
        height: 1.125rem;
        box-sizing: border-box;
        background-color: var(--input-background);
        border: 1px solid var(--input-border);
        border-radius: 0.25rem;
        justify-content: center;
        align-items: center;

        ${props => (props.checked && !props.partialChecked) && css `
            background-color: ${props.color};
            border: none;
        `}

        svg {
          width: 0.688rem;
          height: 0.625rem;
        }
    }
`;
